/**
 * Z-Index 계층 상수
 *
 * 애플리케이션 전역에서 사용되는 z-index 값을 중앙 관리합니다.
 * 값이 클수록 상위 레이어에 표시됩니다.
 *
 * @constant {Object} Z_INDEX
 * @property {number} BOTTOM_NAVIGATION - 하단 네비게이션 바 (50)
 * @property {number} SESSION_PAYMENT - 후불 세션 주문 시트(SessionOrdersSheet) 모달 — 하단 네비 위 (55)
 * @property {number} CHECKOUT_BUTTON - Checkout 페이지 하단 고정 버튼 (100)
 */
export const Z_INDEX = {
  BOTTOM_NAVIGATION: 50,
  // #634: 후불 세션 주문 시트(SessionOrdersSheet) 풀스크린 모달은 하단 네비(50) 위에 떠야 "전체
  // 결제하기"가 네비에 가려지지 않는다(장바구니 담는 중이면 네비가 노출되므로 모달이 위여야 함).
  // 진행바(SessionProgressBar)는 z 를 올리지 않고(모달 역전 방지) 빈 카트 시 PickupCartNav 미렌더로
  // occlusion 을 해소한다.
  SESSION_PAYMENT: 55,
  // #661: 세션 합산결제 모달(구 PAYMENT_MODAL=58)은 전용 페이지(SessionChargePage)로 전환되어
  // z 계층에서 제거됐다 — 결제는 더 이상 오버레이가 아니라 일반 라우트 페이지다.
  CHECKOUT_BUTTON: 100,
} as const;
